import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { computed } from "vue";
import Input from "@/components/input.vue";
import GoogleLogin from "@/components/login/googleLogin.vue";
import FacebookLogin from "@/components/login/facebookLogin.vue";
import { loginState, loginValiadtion } from "@/composable/vuelidate";
import { useMeta } from "vue-meta";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { identify, track } from "@/analytics/events";
const {
  useActions,
  useState
} = createNamespacedHelpers("user");
export default {
  name: "login",
  components: {
    Input,
    GoogleLogin,
    FacebookLogin
  },
  setup() {
    const {
      status,
      provider,
      errorMessage
    } = useState(["status", "provider", "errorMessage"]);
    const {
      login,
      clearErrorMessage
    } = useActions(["login", "clearErrorMessage"]);
    const {
      user
    } = useState(["user"]);
    const loginSubmit = async () => {
      if (await loginValiadtion.value.$validate()) {
        const loginRsponse = await login({
          provider: "email",
          ...loginState
        });
        console.log("loginRsponse", loginRsponse);
        track("Login", {
          provider: "email",
          email: loginState.email
        });
        const updatedUser = user.value;
        const {
          email,
          user_id: userId,
          first_name: firstName,
          last_name: lastName
        } = updatedUser;
        const identifyTraits = {
          email: email,
          first_name: firstName,
          last_name: lastName
        };
        identify(userId, identifyTraits);
        clearErrorMessage(null);
      }
    };
    const resetLoginState = () => {
      Object.keys(loginState).map(key => {
        loginState[key] = null;
      });
      loginValiadtion.value.$reset();
    };
    const removeErrorMessage = () => {
      clearErrorMessage(null);
    };
    resetLoginState();
    const loading = computed(() => {
      return status.value === "pending" ? true : false;
    });
    useMeta({
      title: "Login"
    });
    return {
      loginState,
      loginValiadtion,
      loginSubmit,
      loading,
      status,
      provider,
      errorMessage,
      removeErrorMessage
    };
  }
};